<template>
 <div id="visionAndAction-view" class="minHeight">
   <section class="section-1">
      <div class="build-bg"></div>
      <i-title :titleOne="'我们的愿景'" :titleTwo="'让个人投资与企业借款变得简单'"></i-title>
      <div class="main-title-content">
        <i class="icon-left"></i>
        <i class="icon-right"></i>
        <p>由于长期以来的金融抑制，个人理财产品和中小企业融资市场发展受到制约。一方面，普通出借人由于资产规模较小，难以享受到信息透明、回报可观的理财服务；另一方面，中小企业难以从银行等主流金融机构获得低成本融资，不得不从民间融资渠道高息拆借。</p>
        <p>高质量的应收账款是中小微企业非常优质的资产之一，通过互联网平台实现企业应收账款融资的尝试，始于美国的TRE（The Receivable Exchange)平台。但在中国，由于这类资产难以管理、操作复杂，银行等主流金融机构对这一领域长期漠视，以致于中国每年超过20万亿的应收账款资产极少转化为对中小微企业的融资。</p>
        <p>在此背景下，普惠理财依托于商业保理等供应链金融领域的专业运营经验，运用先进的互联网技术，在企业应收账款资产领域率先实现突破。</p>
        <p>普惠理财旨在建立一个以自由理财、崇尚信用、严格风管的投融资环境；一方面为广大出借人创造一个信息透明、回报较高的网贷平台。令出借人可以在数量丰富、质量优异、资料公开、回报可靠的优质项目库中自由选择项目；另一方面为企业创造一个基于应收账款信用、便捷高效、成本较低的融资渠道，让真正具有成长潜力的中小微企业凭借优质应收账款，获得远远低于民间拆借成本的融资。</p>
      </div>
   </section>
   <section class="section-2">
     <i-title :titleOne="'我们的行动'" :titleTwo="'为出借人提供透明的出借产品'"></i-title>
     <div class="main-title-content">
        <i class="icon-left"></i>
        <i class="icon-right"></i>
        <p>普惠理财团队凭借着丰富的实践经验和广泛的市场触角，发掘高质量应收账款项目，通过普惠理财平台向出借人发布。平台上发布的所有项目，都将以透明的方式披露给出借人。每一笔企业应收账款都将在中国人民银行征信中心的“中登网”(由中国人民银行征信中心建设、我国首个基于互联网运行的应收账款质押登记公示系统，并面向全社会提供应收账款质押登记及查询服务。)上登记，每一款项目都将依据相关监管规定在主管机构备案，每一笔出借资金都在银行存管体系内划拨，除涉及国家法律保护的个人隐私和商业秘密外，企业信息、应收账款信息等资料都将对出借人开放。为出借人提供非常详尽的投资决策依据。</p>
     </div>
   </section>
   <autograph></autograph>
 </div>
</template>

<script>
import autograph from '@/components/autograph'
import informationTitle from '@/components/informationTitle'
export default {
  data () {
    return {
    }
  },
  mounted () {
    this.verifyLogin().then((res) => {}).catch(() => {})
  },
  components: {
    'autograph': autograph,
    'i-title': informationTitle
  }
}
</script>

<style lang="less">
#visionAndAction-view{
  width:980px;
  float: left;
  overflow: hidden;
  background: #fff;
  margin-left: 20px;
  margin-bottom: 20px;
  position: relative;
  .section-1, .section-2{
    .build-bg{
      width: 980px;
      height: 700px;
      background: url(../../assets/images/build-bg.png) no-repeat;
      opacity: 0.3;
      position: absolute;
      top:0px;
    }
    .main-title-content{
      position: relative;
      i {
        position: absolute;
        display: block;
        width: 28px;
        height: 25px;
        background: url(../../assets/images/autograph.png);
      }
      .icon-left{
        top:-40px;
        left:55px;
        background-position: -150px -30px;
      }
      .icon-right{
        background-position: -30px -110px;
        bottom:-10px;
        right: 70px;
      }
      p{
        width: 780px;
        margin: 0 auto;
        margin-bottom: 20px;
        line-height: 2;
        font-size: 14px;
        color: #323232;
      }
    }
  }
  .section-2{
    margin-bottom: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/information/visionAndAction.vue